module.exports = __webpack_public_path__ + "static/media/warrant.53bcf014.png";